import { FormEvent, useEffect, useState } from "react";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { useRegistration } from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { CtaButton } from "../form/styles/cta-button";
import { SingleInput } from "../form/styles/single-input";

export const AddPinComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const [pin, setPin] = useState("");
  const { setRegistrationInfo, writeRegistrationInfo } = useRegistration();

  const isPin = pin && pin.length >= 4;

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (isPin) {
      writeRegistrationInfo();
      props.setStep(RegistrationSteps.Sucess);
    }
  };

  const onBlur = () => {
    setRegistrationInfo({ pin });
  };

  return (
    <AppForm onSubmit={onSubmit}>
      <p>Create your PIN to keep your info secure</p>
      <SingleInput
        onChange={(event: any) => setPin(event.target.value)}
        onBlur={onBlur}
        value={pin}
        placeholder="Your new PIN (4-8 characters)"
      />
      <CtaButton disabled={!isPin}>Next</CtaButton>
    </AppForm>
  );
};
